
/*********************************************************************************************
 * Player vidéo
 *
 */

// Fonction pour activer le son (désactiver le mute) d'une vidéo
// const unmuteVideo = (video) => {
//     video.muted = false;
// };

// Fonction pour jouer la vidéo et cacher le bouton de lecture
const playVideo = (video, player) => {
    video.play();
    player.classList.add("mm-media-play-none");
};

// Fonction pour mettre la vidéo en pause et afficher le bouton de lecture
const pauseVideo = (video, player) => {
    video.pause();
    player.classList.remove("mm-media-play-none");
};

// Fonction pour gérer l'interaction vidéo et le bouton associé
const handleVideoInteraction = (video, player) => {
    const togglePlayPause = () => {
        if (video.paused) {
            playVideo(video, player);
        } else {
            pauseVideo(video, player);
        }
    };

    // Gestion du clic sur le bouton de lecture/pause
    player.addEventListener("click", togglePlayPause);

    // Gestion du clic direct sur la vidéo
    video.addEventListener("click", () => {
        pauseVideo(video, player);
    });
};

// Fonction pour initialiser le player vidéo pour les mobiles
const initMobileVideoPlayer = () => {
    const videoSections = document.querySelectorAll(".mm-media-wrapper");

    videoSections.forEach((section) => {
        const videoMobile = section.querySelector(".mm-faq-video-mobile");
        const playerMobile = section.querySelector(".mm-player-mobile");

        if (videoMobile && playerMobile) {
            handleVideoInteraction(videoMobile, playerMobile);
        }
    });
};

// Fonction pour initialiser le player vidéo pour les desktops
const initDesktopVideoPlayer = () => {
    const videoSections = document.querySelectorAll(".mm-media-wrapper");

    videoSections.forEach((section) => {
        const videoDesktop = section.querySelector(".mm-faq-video-desktop");
        const playerDesktop = section.querySelector(".mm-player-desktop");

        if (videoDesktop && playerDesktop) {
            handleVideoInteraction(videoDesktop, playerDesktop);
        }
    });
};

// Fonction pour vérifier la largeur de l'écran et initialiser le player vidéo en conséquence
const checkScreenWidth = () => {
    if (window.matchMedia("(max-width: 990px)").matches) {
        initMobileVideoPlayer();
    } else {
        initDesktopVideoPlayer();
    }
};

// Fonction principale pour initialiser le player vidéo
const mmInitVideoPlayer = () => {
    checkScreenWidth(); // Applique l'initialisation lors du chargement de la page
};

// Fonction pour détecter quand on entre ou sort d'une section avec vidéo
const observeVideoSections = () => {
    const sections = document.querySelectorAll(".mm-media-wrapper");

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            // Détecter si on est sur mobile ou desktop
            const isMobile = window.matchMedia("(max-width: 990px)").matches;

            // Sélectionner la vidéo correcte selon la taille de l'écran
            const video = isMobile
                ? entry.target.querySelector(".mm-faq-video-mobile")  // Vidéo mobile
                : entry.target.querySelector(".mm-faq-video-desktop");  // Vidéo desktop

            const player = isMobile
                ? entry.target.querySelector(".mm-player-mobile")  // Player mobile
                : entry.target.querySelector(".mm-player-desktop");  // Player desktop

            if (entry.isIntersecting) {
                // Appeler playVideo lorsque la section devient visible
                if (video && player) {
                    playVideo(video, player);
                }
            } else {
                // Appeler pauseVideo lorsque la section n'est plus visible
                if (video && player) {
                    pauseVideo(video, player);
                }
            }
        });
    }, {
        threshold: 0.25 // Déclenche l'événement lorsque 25% de l'élément est visible
    });

    sections.forEach(section => {
        observer.observe(section);
    });
};

// Appeler cette fonction au chargement de la page ou au moment voulu
window.addEventListener('load', observeVideoSections);


// DROPDOWN **********************************************************************************
/*********************************************************************************************
 * Handle dropdown behavior.
 *
 */
const handleDropdown = () => {
	const dropWrappers = document.querySelectorAll('[data-drop="dropdown"]');

	dropWrappers.forEach((item) => {
		item.addEventListener("click", function () {
			dropWrappers.forEach((el) => {
				if (el !== this) {
					el.classList.remove("active");
					if (el.nextElementSibling) el.nextElementSibling.style.maxHeight = null;
				}
			});

			this.classList.toggle("active");
			const content = this.nextElementSibling;

			if (content) {
				content.style.maxHeight = this.classList.contains("active") ? `${content.scrollHeight}px` : null;
			}
		});
	});
};

/*********************************************************************************************
 * Gestion position media par rapport au header
 */
function updateMediaContainerPosition(headerSelector, mediaSelector, breakpoint, height) {
    const headerSection = document.querySelector(headerSelector);
    const mediaContainer = document.querySelector(mediaSelector);

    if (headerSection && mediaContainer) {
        if (window.innerWidth > breakpoint) {
            const headerHeight = headerSection.offsetHeight + height; // Ajoute 24px
            mediaContainer.style.top = headerHeight + "px";
        } else {
            mediaContainer.style.top = ""; // Réinitialise si < breakpoint
        }
    }
}

function updateMediaScrollMargin(headerSelector, mediaSelector, breakpoint, margin) {
    const headerSection = document.querySelector(headerSelector);
    const mediaContainer = document.querySelector(mediaSelector);

    if (headerSection && mediaContainer) {
        if (window.innerWidth > breakpoint) {
            const headerHeight = headerSection.offsetHeight + margin; // Ajoute la marge
            mediaContainer.style.scrollMarginTop = headerHeight + "px";
        } else {
            mediaContainer.style.scrollMarginTop = ""; // Réinitialise si < breakpoint
        }
    }
}


/*********************************************************************************************
 * Fonction principale exécutée après le chargement du DOM
 */
function initializeSectionsWithSplide(attributeName, className, initializeFunction) {
    const sections = document.querySelectorAll(`[${attributeName}]`);

    sections.forEach(function (section) {
        const splideElem = section.querySelector(className);

        if (splideElem !== null && splideElem.querySelectorAll(".splide__slide").length > 0) {
            // Appel dynamique de la fonction passée en paramètre
            initializeFunction(splideElem, section); 
        }
    });
}

/*********************************************************************************************
 * Fonction pour gérer le défilement horizontal
 */
function addHorizontalScrollListener(splideElem, splideInstance) {
    let scrollCounter = 0;

    splideElem.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
            return;
        }

        e.preventDefault();

        scrollCounter++;

        if (scrollCounter >= 12) {
            scrollCounter = 0;

            if (e.deltaX < 0) {
                splideInstance.go('<'); 
            } else if (e.deltaX > 0) {
                splideInstance.go('>'); 
            }
        }
    });
}

// DOM ***************************************************************************************
/*********************************************************************************************
 * Loaded Listenner
 *
 */
document.addEventListener("DOMContentLoaded", () => {
	handleDropdown();
	mmInitVideoPlayer();
	updateMediaContainerPosition(".section-site-header", ".mm-media-container", 990, 24);
	updateMediaContainerPosition(".section-site-header", ".mm-faq-wrapper-media", 990, 0);
	updateMediaScrollMargin(".section-site-header", ".mm-product-form-weight-reco", 100, 16);
});

// Exécute les fonctions au redimensionnement de la fenêtre
window.addEventListener("resize", () => {
    updateMediaContainerPosition(".section-site-header", ".mm-media-container", 990, 24);
    updateMediaContainerPosition(".section-site-header", ".mm-faq-wrapper-media", 990, 0);
	updateMediaScrollMargin(".section-site-header", ".mm-product-form-weight-reco", 100, 16);
});
